export default __webpack_public_path__ + "static/media/disclaimerImage.95077dd6.svg";